import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { stream } from '@app/_models/stream';
import { Observable } from 'rxjs';
import { verifyDocument } from '@app/_models/verifyDocument';
import { headervalue } from 'src/headervalue/header';
import { associateDocList } from '@app/_models/associateDocList';

const httpOptions = {
  // headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })


export class AssociateService {
  url: string;
  constructor(private http: HttpClient) { }

getVerifyDocument(id){
  var temp = this.http.get<any>(`${environment.apiUrl}/AssociateSupervisor/getverifydocument/` + id, httpOptions);
  return temp;
}

editDocument(formData){
  return this.http.post<any>(`${environment.apiUrl}/AssociateSupervisor/updateRecordById`, formData, httpOptions);
}

uploadDocument(formData: FormData){
  return this.http.post<any>(`${environment.apiUrl}/AssociateSupervisor/uploadChangedFile`, formData,{ headers: new HttpHeaders(headervalue.headerWithOnlyJwt) });
}



deleteDocById(id){

  return this.http.delete<any>(`${environment.apiUrl}/AssociateSupervisor/deleteRecordById/`+id, httpOptions);

}

getDocById(id){

  return this.http.get<any>(`${environment.apiUrl}/AssociateSupervisor/getRecordById/`+id, httpOptions);

}

reviewDocs(formData : FormData) {
    // console.log("here")
    // const headers = new HttpHeaders()
    //   .set('Content-type', 'application/json');
    return this.http.post<any>(`${environment.apiUrl}/AssociateManager/reviewUploadStudentInfo`, formData ,{ headers: new HttpHeaders(headervalue.headerWithOnlyJwt) });
  }
  
confirmAssociateDocs(formData,associateId){

    return this.http.post<any>(`${environment.apiUrl}/AssociateManager/uploadStudentInfoFromFile/`+associateId, formData, httpOptions);
}


// addRegister(userdata): Observable<any> {
    
//   return this.http.post(`${environment.apiUrl}/auth/employerSignUp`, userdata,httpOptions).pipe(catchError(this.handleError),);
// }
getAssociateDocList(associateDocList): Observable<any>
{ 
 
  return this.http.post<any>(`${environment.apiUrl}/AssociateManager/getUniversityStudenData`, associateDocList,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });

  //  this.http.post(`${environment.apiUrl}/AssociateManager/getUniversityStudenData` ,associateDocList,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });

// return temp;

}
associateFileSave(formData: FormData) {
  return this.http.post<any>(`${environment.apiUrl}/AssociateManager/associateFileSave`, formData, { headers: new HttpHeaders(headervalue.headerWithOnlyJwt) });

}

autoExcelReading(){
  return this.http.post<any>(`${environment.apiUrl}/AutoReadingExcel/readExcel`, { headers: new HttpHeaders(headervalue.headerWithOnlyJwt) });
}
}